module.exports = __webpack_public_path__ + "img/innovovoice-logo.2963b6a5.svg";